import { ComponentProps } from 'react'

type KakaoPayIconProps = ComponentProps<'img'> & {
  width?: number | string
  height?: number | string
}

export const KakaoPayIcon = ({ width = 49, height = 20, ...props }: KakaoPayIconProps) => {
  return <img src="/images/kakao-pay-yellow-small.png" alt="KakaoPay" width={width} height={height} {...props} />
}

export const KakaoPayDisabledIcon = ({ width = 49, height = 20, ...props }: KakaoPayIconProps) => {
  return (
    <img
      src="/images/kakao-pay-yellow-small.png"
      alt="KakaoPay"
      width={width}
      height={height}
      style={{ borderRadius: 4, filter: 'grayscale(100%)', opacity: 0.6 }}
      {...props}
    />
  )
}
